/**
 * Copies a single key from one synchronous Storage-like object to another.
 *
 * @param {Object} options - Function params
 * @param {Storage} options.from - Source storage.
 * @param {Storage} options.to - Target storage.
 * @param {string} options.key - The key to copy.
 *
 * @throws {Error} If the key is invalid, missing, or getItem is asynchronous.
 */
function copyStorageItem({ from, to, key }) {
  if (typeof key !== 'string' || key === '') {
    throw new Error('"key" must be a non-empty string.');
  }

  const getItem = from?.getItem;
  const setItem = to?.setItem;

  if (typeof getItem !== 'function' || typeof setItem !== 'function') {
    throw new Error('"from" and "to" must implement getItem and setItem.');
  }

  const value = getItem.call(from, key);

  if (value instanceof Promise) {
    throw new Error('"from.getItem" must be synchronous.');
  }

  if (value === null) {
    throw new Error(`Key "${key}" not found in source.`);
  }

  setItem.call(to, key, value);
}

module.exports = {
  copyStorageItem,
};
